import React from 'react';
import gridCellData from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/gridCellData';
import { CellTemplateProps } from 'fulogics-ui-web/dist/layout/dx/DataGrid/templates/CellTemplateProps';
import { GridCellTemplateHelper } from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridCellTemplateHelper';
import PayloadCarrierCountSimpleText from '../../../../components/payload-carrier-count-simple-text/PayloadCarrierCountSimpleText';

const PayloadCarrierCountSimpleTextTemplate = (props: CellTemplateProps) => (
    <>
        <GridCellTemplateHelper cellProps={props}>
            {(inspectorId, disableInspectorForm) => (
                <PayloadCarrierCountSimpleText
                    disableInspectorForm={disableInspectorForm}
                    inspectorId={inspectorId}
                    data={props.data}
                />
            )}
        </GridCellTemplateHelper>
    </>
);

export default PayloadCarrierCountSimpleTextTemplate;
